<template>
  <div class="mt-16">
    <v-container style="max-width: 1185px;padding-bottom:0;padding-top:0;">
      <v-row justify="center" style="margin-bottom:0">
        <v-col
          cols="12"
          cols-md="10"
          align-self="end" style="padding-bottom:0;padding-top:0"
        >
          <ResHL :class="isc+'TXT touchy'">
            <slot name="headline">
            </slot>
          </ResHL>
        </v-col>
      </v-row>
    </v-container>
    <div :class="isc+'BG colorBox'">
      <v-container style="max-width: 1185px; padding-top: 30px;">
        <v-row justify="center">
          <v-col cols="12" cols-md="10">
            <ResHL class="isboxHLTXT">
              <slot name="headlineInBox">
              </slot>
            </ResHL>
          </v-col>
          <v-col cols="12" md="6">
            <slot name="left">
            </slot>
          </v-col>
          <v-col cols="12" md="6">
            <slot name="right">
            </slot>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import ResHL from '../components/ResHL' // responsive Headline
export default {
  name: 'CntBrd',
  components: {
    ResHL
  },
  props: {
    isc: String
  }
}
</script>
